var React = require('react');

function Pdf (props) {
    return React.createElement("svg",props,[React.createElement("path",{"style":{"fill":"#ffffff","stroke":"none"},"d":"m 65,3 0,19 19,0 z","key":0}),React.createElement("path",{"style":{"fill":"#EBEBDA","stroke":"#777777","strokeWidth":"2"},"d":"m 65,3 0,19 19,0 0,74 -72,0 0,-93 53,0 19,19","key":1}),React.createElement("path",{"style":{"fill":"none","stroke":"#C01A1A","strokeWidth":"4"},"d":"m 49,56 c -17,4 -27,10 -29,14 -2,4 -1,9 6,4 7,-5 20,-32 23,-53 1,-7 -7,-11 -7,-2 0,12 6,34 30,41 9,2 10,-7 0,-7 -10,0 -23,3 -23,3 z","key":2})]);
}

Pdf.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 100 100","version":"1.1"};

module.exports = Pdf;

Pdf.default = Pdf;
